// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCOQ-AOhkNcce2U-0jJDZF23fJwiLxoYq8",
//   authDomain: "kilobahub.firebaseapp.com",
//   projectId: "kilobahub",
//   storageBucket: "kilobahub.firebasestorage.app",
//   messagingSenderId: "720444628856",
//   appId: "1:720444628856:web:86a68bf8c64be16223728d",
//   measurementId: "G-EL5FRKWCLF"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAEXZMTPubp9USyMop-s9J6SSxTIq1fn-w",
  authDomain: "kilobagame.firebaseapp.com",
  projectId: "kilobagame",
  storageBucket: "kilobagame.firebasestorage.app",
  messagingSenderId: "514206156727",
  appId: "1:514206156727:web:8c329673d0df4f1b384a32",
  measurementId: "G-7JCBXD3P5W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// const appCheck = initializeAppCheck(app, {
//   provider: new ReCaptchaV3Provider('6Lf5JM4rAAAAACY2EbLG-oep1B6SrwGsOH3fhaYW'),

//   isTokenAutoRefreshEnabled: true
// });



// Initialize Firebase Cloud Messaging and get a reference to the service
let messaging: any = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  messaging = getMessaging(app);
}

export { app, analytics, auth, messaging, getToken, onMessage };
